import Button from '@hellodarwin/core/lib/components/common/button';
import Div from '@hellodarwin/core/lib/components/common/div';
import { MediumDesktop } from '@hellodarwin/core/lib/components/common/Media';
import Typography from '@hellodarwin/core/lib/components/common/typography';
import Check from '@hellodarwin/icons/dist/icons/Check';
import { PropsWithChildren, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import useOnboardingFlow from '../../../../../../../../hooks/useOnboardingFlow';
import { ExpertEligibleOverlay, ExpertEligiblePanel } from './styles';

const OnboardingTalkToExpertOverlay: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const { disableExpertEligible, openExpertLink, isExpertEligible } =
    useOnboardingFlow();
  const lines: string[] = useMemo(
    () => [
      t('onboardingClient|expertEligibleLine1'),
      t('onboardingClient|expertEligibleLine2'),
      t('onboardingClient|expertEligibleLine3'),
      t('onboardingClient|expertEligibleLine4'),
    ],
    [t],
  );

  if (!isExpertEligible) return children;
  return (
    <>
      {children}
      <MediumDesktop direction="up">
        <ExpertEligibleOverlay>
          <ExpertEligiblePanel>
            <Div flex="column" gap={theme.appearance.spacing * 1.5}>
              <Typography elementTheme={'h4'} textAlign="center">
                {t('onboardingClient|expertEligibleTitle')}
              </Typography>
              <Typography
                elementTheme={'body1'}
                color={theme.colors.grey_2}
                textAlign="center"
              >
                {t('onboardingClient|expertEligibleSubTitle')}
              </Typography>
            </Div>
            <Div flex="column" gap={theme.appearance.spacing * 1}>
              {lines.map((line, index) => (
                <Div
                  key={index}
                  flex="row"
                  align="center"
                  gap={theme.appearance.spacing * 2}
                >
                  <Check size={16} />
                  <Typography elementTheme={'body2'}>{line}</Typography>
                </Div>
              ))}
            </Div>
            <Div
              flex="column"
              gap={theme.appearance.spacing * 1}
              align="center"
              style={{ marginBlockStart: theme.appearance.spacing * 2 }}
              justify="center"
            >
              <Button
                defaultStyle={theme.colors.grey_1}
                onClick={openExpertLink}
                size="medium"
              >
                {t('onboardingClient|contactExpert')}
              </Button>
              <Button onClick={() => disableExpertEligible()} isLink>
                {t('onboardingClient|continue')}
              </Button>
            </Div>
          </ExpertEligiblePanel>
        </ExpertEligibleOverlay>{' '}
      </MediumDesktop>
    </>
  );
};

export default OnboardingTalkToExpertOverlay;
